import type { TeamCreate, TeamSummary, TeamUpdate } from '@solidops/shared/teams';
import {
  createTeam as createTeamRequest,
  getGetTeamQueryKey,
  getGetTeamQueryOptions,
  getListTeamsQueryKey,
  getListTeamsQueryOptions,
  updateTeam as updateTeamRequest,
} from './generated/teams/teams.js';

export const getTeamQueryKey = getGetTeamQueryKey;
export const getTeamsQueryKey = getListTeamsQueryKey;

export function getTeamsQueryOptions(input: {
  query?: string;
  active?: 'true' | 'false';
  cursor?: string;
  limit?: number;
}) {
  // A directory page is intentionally bounded. Rendering fewer rows on the first
  // screen keeps the admin shell responsive under the documented constrained
  // browser profile; pagination still exposes the complete directory.
  return getListTeamsQueryOptions({ ...input, limit: input.limit ?? 20 });
}

export function getTeamQueryOptions(teamId: string) {
  return getGetTeamQueryOptions(teamId);
}

export function createTeam(input: TeamCreate & { csrfToken: string; idempotencyKey: string }) {
  return createTeamRequest(
    { name: input.name, description: input.description },
    {
      headers: {
        'x-csrf-token': input.csrfToken,
        'idempotency-key': input.idempotencyKey,
      },
    },
  ) as Promise<TeamSummary>;
}

export function updateTeam(
  teamId: string,
  input: TeamUpdate & { csrfToken: string; idempotencyKey: string },
) {
  const { csrfToken, idempotencyKey, ...body } = input;
  return updateTeamRequest(teamId, body, {
    headers: {
      'x-csrf-token': csrfToken,
      'idempotency-key': idempotencyKey,
    },
  }) as Promise<TeamSummary>;
}
